import type { ContractErpTerms } from "../api/contracts";
import type { SelectOption } from "../components/Select";

/**
 * The payment terms a contract or order form offers its customer, in the server's order: the most used under one
 * heading and the rest under another. A term the record already has stays on top; it is marked as off the ERP's list
 * only when the ERP does not know it at all, since a term of the other language or out of use is still the ERP's.
 */
export function paymentTermOptions(
  current: string,
  terms: ContractErpTerms["paymentTerms"],
  labels: { mostUsed: string; other: string; notInErp: string },
): SelectOption<string>[] {
  const offered = terms.filter((p) => p.offered);
  // Until the list arrives, nothing is known to be off it.
  const known = terms.length === 0 || terms.some((p) => p.name === current);
  const kept = current !== "" && !offered.some((p) => p.name === current)
    ? [{ value: current, label: known ? current : `${current} (${labels.notInErp})` }]
    : [];
  return [
    { value: "", label: "—" },
    ...kept,
    ...offered.map((p) => ({ value: p.name, label: p.name, group: p.mostUsed ? labels.mostUsed : labels.other })),
  ];
}
